$(function () {
  // Split dates (ddmmyyyy and mmyyyy)
  $('.js-minerva-form-split-date').each(function () {
    var $container = $(this),
        $hiddenInput = $container.find('input[type="hidden"]'),
        $dayInput = $container.find('.js-day'),
        $monthInput = $container.find('.js-month'),
        $yearInput = $container.find('.js-year'),
        day = $dayInput.val() === undefined ? 1 : $dayInput.val(),  // default to 1 for mmyyyy format
        month = $monthInput.val(),
        year = $yearInput.val();
    const today = $container.find('.js-today');

    today.click(function () {
      // update date to today
      const date = new Date();
      day = date.getDate();
      month = date.getMonth() + 1;
      year = date.getFullYear();
      $dayInput.val(day);
      $monthInput.val(month);
      $yearInput.val(year);
      updateHiddenInput();

    });

    function updateHiddenInput() {
      if (year && month && day) {
        $hiddenInput.val(year + "-" + month + "-" + day);
      } else {
        $hiddenInput.val("");
      }
    }
    $dayInput.bind("change", function () {
      day = this.value;
      updateHiddenInput();
    });
    $monthInput.bind("change", function () {
      month = this.value;
      updateHiddenInput();
    });
    $yearInput.bind("change", function () {
      year = this.value;
      updateHiddenInput();
    });
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/split-date.js